<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <!-- v-show="disabled" -->
                <!-- <c-btn
                  v-show="disabled"
                  label="출력"
                  icon="print"
                  @btnClicked="printTbm"
                />
                <q-btn v-if="editable && popupParam.tbmId" class="custom-btn" label="" icon="qr_code_scanner" color="black" size="md">
                  <q-popup-proxy>
                    <c-card title="QR코드" class="cardClassDetailForm">
                      <template slot="card-detail">
                        <div class="row">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="wrap" action="#" id="printJS-form">
                              <vue-qrcode
                                :value="serverName+'/sai/tbm/tbm?tbmId='
                                + popupParam.tbmId" 
                                :options="{ width: 180 }"
                                class="canvas"
                              >
                              </vue-qrcode>
                              <span class="facilityStyle">
                                <p class="abc" >
                                  <b>{{'-TBM명 : '}}</b>{{data.tbmName}}
                                  <br>
                                  <b>{{'-작업일 : '}} </b>{{data.tbmWorkDate}}
                                </p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </c-card>
                  </q-popup-proxy>
                </q-btn>
                <c-btn
                  v-show="editable && !popupParam.tbmId"
                  label="불러오기"
                  icon="save_alt"
                  @btnClicked="copyTbm"
                />
                <c-btn
                  v-show="editable && popupParam.tbmId && !disabled"
                  label="삭제"
                  :editable="editable"
                  icon="delete_forever"
                  @btnClicked="remove"
                />
                <c-btn
                  v-show="editable && popupParam.tbmId && !disabled"
                  :url="completeUrl"
                  :isSubmit="isComplete"
                  :param="data"
                  mappingType="PUT"
                  label="완료"
                  icon="check"
                  @beforeAction="completeTbm"
                  @btnCallback="completeCallback"
                />
                <c-btn
                  v-show="editable && !disabled"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="saveType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveTbm"
                  @btnCallback="saveCallback"
                /> -->
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :editable="editable"
                  :disabled="true"
                  label="TBM번호"
                  name="tbmNo"
                  v-model="data.tbmNo"
                >
                </c-text>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :afterIcon="
                    editable && !disabled
                      ? [
                          {
                            name: 'search',
                            click: true,
                            callbackName: 'searchWorkPermit',
                          },
                          {
                            name: 'close',
                            click: true,
                            callbackName: 'removeWorkPermit',
                          },
                        ]
                      : null
                  "
                  :editable="editable"
                  :readonly="true"
                  label="작업허가번호"
                  name="permitNo"
                  v-model="data.permitNo"
                  @searchWorkPermit="searchWorkPermit"
                  @removeWorkPermit="removeWorkPermit"
                >
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="TBM명"
                  name="tbmName"
                  v-model="data.tbmName"
                >
                </c-text>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <c-datepicker
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="작업일"
                  type="date"
                  name="tbmWorkDate"
                  v-model="data.tbmWorkDate"
                >
                </c-datepicker>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <c-vendor
                  required
                  :editable="editable"
                  :disabled="disabled"
                  :haveProcess="true"
                  label="업체"
                  name="vendorCd"
                  v-model="data.vendorCd"
                />
              </div>
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <c-process
                  :editable="editable"
                  :disabled="isWorkPermit || disabled"
                  label="공정"
                  name="processCd"
                  v-model="data.processCd"
                >
                </c-process>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :disabled="isWorkPermit || disabled"
                  :editable="editable"
                  label="작업"
                  name="sopName"
                  v-model="data.sopName"
                >
                </c-text>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <!-- 작업허가서의 업체감독자, 공사현장 선택시 안전관리책임자 -->
                <c-field
                  :editable="editable"
                  :disabled="disabled"
                  label="작업책임자"
                  name="tbmWorkResponsibleId"
                  v-model="data.tbmWorkResponsibleId">
                </c-field>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <c-plant
                  required
                  :editable="editable"
                  :disabled="isWorkPermit || disabled"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <!-- 관련공사 -->
                <c-construnction
                  :disabled="disabled"
                  :editable="editable"
                  name="sopConstructionId"
                  v-model="data.sopConstructionId">
                </c-construnction>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-checkbox
                  :disabled="disabled"
                  :editable="editable"
                  :isArray="false"
                  codeGroupCd="TBM_PRE_INSPECTION_CD"
                  itemText="codeName"
                  itemValue="code"
                  label="사전점검"
                  name="preInspections"
                  v-model="data.preInspections"
                >
                </c-checkbox>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  label="작업내용"
                  name="tbmWorkContents"
                  v-model="data.tbmWorkContents"
                >
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  label="특이사항"
                  name="significant"
                  v-model="data.significant"
                >
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-table
            ref="riskTable"
            title="위험요인 목록"
            :columns="grid.columns"
            :gridHeight="grid.height"
            :data="data.tbmRiskHazardModelList"
            :isTitle="true"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            noDataLabel="위험요인을 추가하세요."
            :gridHeightAuto="true"
            :hideBottom="false"
            :editable="editable && !disabled"
            rowKey="tbmRiskId"
            selection="multiple"
          >
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn
                  v-if="editable && !disabled"
                  :showLoading="false"
                  label="추가"
                  icon="add"
                  @btnClicked="addRisk"
                />
                <c-btn
                  v-if="
                    editable &&
                    !disabled &&
                    data.tbmRiskHazardModelList.length > 0
                  "
                  :showLoading="false"
                  label="제외"
                  icon="remove"
                  @btnClicked="removeRisk"
                />
              </q-btn-group>
            </template>
            <template v-slot:customArea="{ props, col }">
              <template v-if="col.name ==='tbmJobStep'">
                <c-text-column
                  v-if="props.row['tbmPermitFlag'] === 'N'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmJobStep']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmJobStep']}}
                </span>
              </template>
              <template v-if="col.name ==='tbmRiskHazard'">
                <c-text-column
                  v-if="props.row['tbmPermitFlag'] === 'N'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmRiskHazard']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmRiskHazard']}}
                </span>
              </template>
              <template v-if="col.name ==='tbmImprovementMeasures'">
                <c-text-column
                  v-if="props.row['tbmPermitFlag'] === 'N'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmImprovementMeasures']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmImprovementMeasures']}}
                </span>
              </template>
            </template>
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-table
            ref="attendeeTable"
            title="참석자 및 건강상태 목록"
            :columns="grid2.columns"
            :gridHeight="grid2.height"
            :data="data.tbmAttendeeModelList"
            :isTitle="true"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            noDataLabel="참석자가 없습니다."
            :gridHeightAuto="true"
            :hideBottom="false"
            :editable="editable&&!disabled"
            selection="multiple"
            rowKey="tbmAttendeeId"
            
          >
            <template slot="table-button">
              <q-btn-group outline>
                <!-- <c-btn
                  v-if="isWorkPermit"
                  :showLoading="false"
                  label=""
                  icon="save_alt"
                  @btnClicked="workPermitLoadAttendee"
                /> -->
                <c-btn
                  v-if="editable && !disabled"
                  :showLoading="false"
                  label="선택"
                  icon="add"
                  @btnClicked="addAttendee1"
                />
                <c-btn
                  v-if="editable && !disabled"
                  :showLoading="false"
                  label="직접"
                  icon="add"
                  @btnClicked="addAttendee2"
                />
                <c-btn
                  v-if="
                    editable &&
                    !disabled &&
                    data.tbmAttendeeModelList.length > 0
                  "
                  :showLoading="false"
                  label=""
                  icon="remove"
                  @btnClicked="removeAttendee"
                />
              </q-btn-group>
            </template>
            <template v-slot:customArea="{ props, col }">
              <template v-if="col.name ==='tbmAttendeeUserName'">
                <c-text-column
                  v-if="props.row['tbmDirectFlag'] === 'Y'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmAttendeeUserName']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmAttendeeUserName']}}
                </span>
              </template>
              <template v-if="col.name ==='tbmAttendeeJobName'">
                <c-text-column
                  v-if="props.row['tbmDirectFlag'] === 'Y'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmAttendeeJobName']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmAttendeeJobName']}}
                </span>
              </template>
              <template v-if="col.name === 'click'">
                <q-btn 
                  round unelevated 
                  size="xs"
                  color="amber" 
                  icon="mode"
                  @click.stop="() => { rowIndex = props.rowIndex, electronSignature = props.row.electronSignature}"
                  >
                  <q-popup-proxy :ref="'proxy_' + props.rowIndex" :breakpoint="400">
                    <component
                      :is="col.component"
                      :outFlag="true"
                      :popupParam="props.row"
                      :data="data"
                      :rowIndex="props.rowIndex"
                      @callback="callback"
                    />
                  </q-popup-proxy>
                </q-btn>
              </template>
            </template>
          </c-table>
        </div>
        <div class="col-12">
          <c-upload 
            :attachInfo="attachInfo"
            :editable="editable&&!disabled"
            label="교육자료">
          </c-upload>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
    <div class="popup-bottom-bar">
      <div class="popup-bottom-bar-btngroup">
        <q-btn-group outline >
          <c-btn
            :flat="true"
            v-show="editable && !popupParam.tbmId"
            label="불러오기"
            icon="save_alt"
            @btnClicked="copyTbm"
          />
          
          <c-btn
            :flat="true"
            v-show="editable && popupParam.tbmId && !disabled"
            label="삭제"
            :editable="editable"
            icon="delete_forever"
            @btnClicked="remove"
          />
          
          <!-- [S]결재관련 버튼 -->
          <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
          <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
          <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
          <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
          <c-appr-btn 
            :flat="true"
            ref="appr-btn"
            name="danger-journal-appr-btn"
            :editable="editable"
            :approvalInfo="approvalInfo"
            @beforeApprAction="saveDataAppr"
            @callbackApprAction="approvalCallback"
            @requestAfterAction="getDetail"
          />
          <!-- <c-btn
            :flat="true"
            v-show="editable && popupParam.tbmId && !disabled"
            :url="completeUrl"
            :isSubmit="isComplete"
            :param="data"
            mappingType="PUT"
            label="완료"
            icon="check"
            @beforeAction="completeTbm"
            @btnCallback="completeCallback"
          /> -->
          <c-btn
            :flat="true"
            v-show="editable && !disabled"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="data"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveTbm"
            @btnCallback="saveCallback"
          />
        </q-btn-group>
      </div>
      <div class="popup-bottom-bar-close">
        <q-btn flat color="gray" icon="arrow_back" @click="closePopUps" />
      </div>
    </div>
  </div>
</template>
<script>
import { uid } from "quasar";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
// 스크롤시 저장버튼(최초)
import mixinCommon from '@/js/mixin-page-common'
export default {
  mixins: [mixinCommon],
  name: "tbm-info",
  components: {
    VueQrcode
  },
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          tbmId: "",
        };
      },
    },
    // 스크롤시 저장버튼(최초)
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
  },
  data() {
    return {
      data: {
        tbmId: "",
        tbmNo: "",
        plantCd: "",
        permitNo: "",
        sopName: "",
        mapName: '',
        tbmWorkResponsibleId: "",
        tbmWorkResponsibleName: "",
        tbmName: "",
        tbmWorkDate: "",
        tbmWorkArea: "",
        tbmWorkContents: "",
        significant: "",
        tbmCompleteFlag: 'N',
        processCd: "",
        vendorCd: "",
        sopWorkPermitId: "",
        preInspections: "",
        tbmWorkPermitFlag: 'N',
        companyCd: '',

        tbmAttendeeModelList: [],
        tbmRiskHazardModelList: [],

        deleteTbmAttendeeModelList: [],
        deleteTbmRiskHazardModelList: [],
      },
      grid: {
        columns: [
          {
            name: "tbmJobStep",
            field: "tbmJobStep",
            label: "작업단계",
            align: "left",
            style: "width:40%",
            type: "text",
            sortable: false,
            colClass: 6,
          },
          {
            name: "tbmRiskHazard",
            field: "tbmRiskHazard",
            label: "위험요인",
            align: "left",
            style: "width:60%",
            type: "text",
            sortable: false,
            colClass: 6,
          },
          // {
          //   name: "tbmImprovementMeasures",
          //   field: "tbmImprovementMeasures",
          //   label: "안전대책",
          //   style: "width:40%",
          //   type: "text",
          //   align: "left",
          //   sortable: false,
          //   colClass: 12,
          // },
        ],
        height: "500px",
        data: [],
      },
      grid2: {
        columns: [],
        height: '500px',
        data: [],
      },
      changeItem: {
        plant: '',
        process: '',
        vendor: '',
      },
      getUrl: "",
      saveUrl: "transactionConfig.sai.tbm.insert.url",
      completeUrl: "transactionConfig.sai.tbm.complete.url",
      deleteUrl: "",
      updateUrl: "",
      printUrl: "",
      getRespondUrl: '',
      getWorkPermitUrl: '',
      saveType: "POST",
      isSave: false,
      isComplete: false,
      isEdit: false,
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        isFull: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      editable: false,
      serverName: '',
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'TBM_EDUCATION',
        taskKey: '',
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.data.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.data.approvalStatusCd, 
        apprEditable: !this.disabled && this.data.tbmId, // 결재버튼 활성화 기준
        param: this.data, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000018', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          tbmId: this.data.tbmId,
          isApprContent: true
        },
        approvalRequestName: 'TBM ['+this.data.tbmName+']', // 결재요청명 (문서 title)
        approvalConnId: this.data.tbmId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    isWorkPermit() {
      return (
        Boolean(this.data.sopWorkPermitId) &&
        this.editable
      );
    },
    disabled() {
      return this.data.tbmCompleteFlag === "Y"|| this.data.approvalStatusCd === 'ASC0000001';
    },
    isPlant() {
      return Boolean(!this.data.plantCd)
    },
    isProcess() {
      return Boolean(!this.data.plantCd) || Boolean(!this.data.processCd)
    },
    isVendor() {
      if (this.$store.getters.user.innerFlag === 'N') {
        return true;
      } else {
        return false;
      }
    },
    // 스크롤시 저장버튼(최초)
    mobileSave() {
      return {
        bol: this.editable && !this.disabled,
        uid: uid(),
      }
    },
  },
  // 스크롤시 저장버튼(최초)
  watch: {
    'eventScroll.save'() {
      this.saveTbm();
    },
  },
  // * 작업허가서 있을때
  // - 프로젝트, 공종, 업체, 작업, 작업책임자(업체감독자), 작업장소, 작업일, 작업내용 전부 disabled
  // - 참석자 : 작업허가서의 작업자
  // * 작업허가서 없을때
  // - 공사현장과 관련된 공종 선택
  // - 작업장소 : 공사현장 > 작업장소
  // - 작업책임자 : 하도급 > 안전책임자
  // - 작업 : 공종, 업체에 맞는 작업 선택
  // - 업체 : 프로젝트와 공종에 맞는 하도급 선택
  // - 위험요인 목록  작업과 관련된 작업단계(직접추가 제외)
  // - 참석자 : 직영일때 사용자 추가(이름, 직책/직무 수정X), 업체일때 행추가(이름, 직책/직무 수정O) 
  methods: {
    init() {
      this.editable = this.$route.meta.editable;

      this.getUrl = selectConfig.sai.tbm.get.url;
      this.getRespondUrl = selectConfig.sai.tbm.respond.url;
      this.getWorkPermitUrl = selectConfig.sop.swp.workPermit.get.url;
      this.insertUrl = transactionConfig.sai.tbm.insert.url;
      this.updateUrl = transactionConfig.sai.tbm.update.url;
      this.completeUrl = transactionConfig.sai.tbm.complete.url;
      this.deleteUrl = transactionConfig.sai.tbm.delete.url;
      this.printUrl = selectConfig.sai.tbm.print.url;
      this.eventScroll.position = 50
      this.getDetail();
      this.setHeader();
    },
    getDetail() {
      if (this.popupParam.tbmId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.tbmId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = this.$_.clone(_result.data);

          this.$_.forEach(this.data.tbmAttendeeModelList, _item => {
            _item.headerName = _item.tbmAttendeeUserName
          })
          this.$set(this.attachInfo, 'taskKey', this.popupParam.tbmId);
        },);
      } else {
        // this.data.tbmWorkDate = this.$comm.getToday();
      }
    },
    
    setHeader() {
      this.$comm.getComboItems('TBM_HEALTH_STATUS_CD').then(_item => {
        this.grid2.columns = [
          {
            name: "tbmAttendeeUserName",
            field: "tbmAttendeeUserName",
            label: "참석자",
            align: "center",
            fix: true,
            sortable: false,
            colClass: 3,
          },
          {
            name: 'healthStatusCd',
            field: 'healthStatusCd',
            label: '상태',
            type: 'select',
            setHeader: true,
            style: 'width:90px',
            align: 'center',
            comboItems: _item,
            sortable: false,
            colClass: 2,
          },
          {
            name: 'click',
            field: 'click',
            label: '서명',
            style: 'width:50px',
            type: 'custom',
            align: 'center',
            sortable: false,
            colClass: 1,
            component: () => import(`${'./tbmAttendSignature.vue'}`)
          },
          {
            name: 'mentalFatigueFlag',
            field: 'mentalFatigueFlag',
            label: '정신',
            style: 'width:50px', 
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
            colClass: 2,
          },
          {
            name: 'mentalPhychologicalFlag',
            field: 'mentalPhychologicalFlag',
            label: '심리',
            style: 'width:50px', 
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
            colClass: 2,
          },
          {
            name: 'mentalPhysicalFlag',
            field: 'mentalPhysicalFlag',
            label: '육체',
            style: 'width:50px', 
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
            colClass: 2,
          },
          {
            name: 'physicalDefectFlag',
            field: 'physicalDefectFlag',
            label: '신체',
            style: 'width:50px', 
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
            colClass: 2,
          },
          // {
          //   name: 'eduAttendFlag',
          //   field: 'eduAttendFlag',
          //   label: '교육참석',
          //   style: 'width:70px', 
          //   align: 'center',
          //   type: 'check',
          //   true: 'Y',
          //   false: 'N',
          //   sortable: false,
          //   colClass: 1,
          // },
        ]
      });
    },
    saveTbm() {
      if (this.popupParam.tbmId) {
        this.saveUrl = this.updateUrl;
        this.saveType = "PUT";
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = "POST";
        this.data.companyCd = this.$store.getters.user.companyCd;
      }
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "저장하시겠습니까?",
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.$_.forEach(this.data.tbmRiskHazardModelList, item => {
                item.chgUserId = this.$store.getters.user.userId
              })
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(_result) {
      this.popupParam.tbmId = _result.data
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getDetail();
    },
    completeTbm() {
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
            window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "TBM을 완료하시겠습니까?",
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isComplete = !this.isComplete;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    completeCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getDetail();
    },
    addRisk() {
      this.data.tbmRiskHazardModelList.splice(0, 0, {
        tbmId: this.popupParam.tbmId,
        tbmRiskId: uid(),
        tbmJobStep: "",
        tbmRiskHazard: "",
        tbmImprovementMeasures: "",
        tbmSopFlag: "N",
        tbmJsaFlag: "N",
        tbmDirectFlag: "Y",
        tbmPermitFlag: "N",
        regUserId: this.$store.getters.user.userId,
        remarks: "",
        editFlag: "C",
        type: '직접입력'
      });
    },
    removeRisk() {
      let selectData = this.$refs["riskTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내", // 안내
          message: "하나 이상 선택하세요.", // 하나 이상 선택하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, (item) => {
          if (!this.data.deleteTbmRiskHazardModelList) {
            this.data.deleteTbmRiskHazardModelList = [];
          }
          if (
            this.$_.findIndex(this.data.deleteTbmRiskHazardModelList, {
              tbmRiskId: item.tbmRiskId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.data.deleteTbmRiskHazardModelList.push(item);
          }
          this.data.tbmRiskHazardModelList = this.$_.reject(
            this.data.tbmRiskHazardModelList,
            item
          );
        });
      }
    },
    copyTbm() {
      this.popupOptions.title = "타 TBM 검색"; // SOP 검색
      this.popupOptions.param = {
        type: "single",
      };
      this.popupOptions.target = () => import(`${"./tbmPop.vue"}`);
      this.popupOptions.width = '99%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeCopyTbmPopup;
    },
    closeCopyTbmPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.data.tbmRiskHazardModelList = [];
      if (data && data.length > 0) {
        if (data[0].tbmId) {
          this.$http.url = this.$format(this.getUrl, data[0].tbmId);
          this.$http.type = "GET";
          this.$http.request((_result) => {
            this.data.plantCd = _result.data.plantCd;
            this.data.permitNo = _result.data.permitNo;
            this.data.sopName = _result.data.sopName;
            this.data.tbmName = _result.data.tbmName;
            this.data.tbmWorkResponsibleId =
              _result.data.tbmWorkResponsibleId;
            this.data.tbmWorkResponsibleName =
              _result.data.tbmWorkResponsibleName;
            // this.data.tbmWorkDate = _result.data.tbmWorkDate;
            this.data.tbmWorkArea = _result.data.tbmWorkArea;
            this.data.tbmWorkContents = _result.data.tbmWorkContents;
            this.data.tbmCompleteFlag = "N";
            this.data.processCd = _result.data.processCd;
            this.data.vendorCd = _result.data.vendorCd;
            this.data.sopWorkPermitId = _result.data.sopWorkPermitId;
            this.data.preInspections = _result.data.preInspections;
            this.data.tbmAttendeeModelList =
              _result.data.tbmAttendeeModelList;
            this.data.tbmRiskHazardModelList =
              _result.data.tbmRiskHazardModelList;
            this.data.tbmHazardEquipModelList =
              _result.data.tbmHazardEquipModelList;
          });
        }
      }
    },
    // 작업허가서 선택
    searchWorkPermit() {
      if (!this.data.plantCd) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '공사현장을 선택하세요.',
          type: 'warning', // success / info / warning / error
        });
      }
      this.popupOptions.title = "작업허가서 선택"; // 작업허가서 선택
      this.popupOptions.param = {
        type: "single",
        plantCd: this.data.plantCd, 
        vendorCd: this.data.vendorCd, 
        popupMode: 'Y',
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/swp/safeWorkPermitPop.vue"}`);
      this.popupOptions.width = '99%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeWorkPermitPopup;
    },
    closeWorkPermitPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.data.tbmAttendeeModelList = [];
      if (data && data.length > 0) {
      this.$http.url = this.$format(this.getWorkPermitUrl, data[0].sopWorkPermitId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data.sopWorkPermitId = _result.data.sopWorkPermitId
        this.data.permitNo = _result.data.permitNo // 허가번호
        // this.data.tbmWorkDate = _result.data.permitDate // 작업일
        this.data.processCd = _result.data.processCd // 공종
        this.data.vendorCd = _result.data.vendorCd // 업체
        this.data.tbmWorkResponsibleId = _result.data.maintenanceDeptCheckUserId // 책임자
        this.data.tbmWorkResponsibleName = _result.data.maintenanceDeptCheckUserName // 책임자
        this.data.sopName = _result.data.sopName // 작업
        this.data.tbmName = _result.data.workSummary // TBM명
        this.data.tbmWorkContents = '' // 작업내용
        this.data.tbmWorkPermitFlag = "Y" // 작업허가서 유 
        
        this.$_.forEach(this.data.tbmRiskHazardModelList, (item) => {
          if (!this.data.deleteTbmRiskHazardModelList) {
            this.data.deleteTbmRiskHazardModelList = [];
          }
          if (
            this.$_.findIndex(this.data.deleteTbmRiskHazardModelList, {
              tbmRiskId: item.tbmRiskId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.data.deleteTbmRiskHazardModelList.push(item);
          }
          this.data.tbmRiskHazardModelList = this.$_.reject(
            this.data.tbmRiskHazardModelList,
            item
          );
        });
        this.data.tbmRiskHazardModelList = [];
        if (_result.data.workers && _result.data.workers.length > 0) {
          this.$_.forEach(_result.data.workers, _item => {
            let index = this.$_.findIndex(this.data.tbmAttendeeModelList, {
              tbmAttendeeUserName: _item.workerName, 
              tbmAttendeeJobName: _item.roleName, 
            });
            if (index === -1) {
              this.data.tbmAttendeeModelList.push({
                tbmId: this.popupParam.tbmId,
                tbmAttendeeId: uid(),
                tbmAttendeeUserId: _item.userId,
                tbmAttendeeUserName: _item.workerName,
                tbmAttendeeJobName: _item.roleName,
                healthStatusCd: "THS0000001",
                mentalFatigueFlag: "N",
                mentalPhychologicalFlag: "N",
                mentalPhysicalFlag: "N",
                physicalDefectFlag: "N",
                tbmPermitFlag: "Y",
                regUserId: this.$store.getters.user.userId,
                editFlag: "C",
              })
            }
          })
        } 
        if (_result.data.assessments && _result.data.assessments.length > 0) {
          this.$_.forEach(_result.data.assessments, _item => {
            let index = this.$_.findIndex(this.data.tbmRiskHazardModelList, {
              tbmJobStep: _item.jobStepName, 
              tbmRiskHazard: _item.riskHazardName, 
            });
            if (index === -1) {
              this.data.tbmRiskHazardModelList.push({
                tbmId: this.popupParam.tbmId,
                tbmRiskId: uid(),
                tbmJobStep: _item.jobStepName,
                deptName: _item.deptName,
                tbmRiskHazard: _item.riskHazardName,
                tbmImprovementMeasures: _item.safetyActionMeasures,
                electronSignature: '',
                tbmSopFlag: "N",
                tbmJsaFlag: "N",
                tbmDirectFlag: "N",
                eduAttendFlag: 'N',
                tbmPermitFlag: "Y",
                regUserId: this.$store.getters.user.userId,
                remarks: "",
                editFlag: "C",
                type: '작업허가서'
              })
            }
          })
        } 
      },);
      }
    },
    removeWorkPermit() {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message:
            "해당 작업허가서에 지정된 기본 정보들과 작업자가 삭제됩니다.\n\r진행하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.data.sopWorkPermitId = '';
          this.data.permitNo = '';
          this.data.processCd = '';
          this.data.sopName = '';
          this.data.vendorCd = '';
          this.data.vendorName = '';
          this.data.tbmWorkDate = '';
          this.data.tbmWorkResponsibleId = '';
          this.data.tbmWorkResponsibleName = '';
          this.data.mapName = '';
          this.data.tbmAttendeeModelList = [];
          this.$_.forEach(this.data.tbmRiskHazardModelList, (item) => {
          if (!this.data.deleteTbmRiskHazardModelList) {
            this.data.deleteTbmRiskHazardModelList = [];
          }
          if (
            this.$_.findIndex(this.data.deleteTbmRiskHazardModelList, {
              tbmRiskId: item.tbmRiskId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.data.deleteTbmRiskHazardModelList.push(item);
          }
          this.data.tbmRiskHazardModelList = this.$_.reject(
            this.data.tbmRiskHazardModelList,
            item
          );
        });
          this.data.tbmRiskHazardModelList = [];
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: 'TBM을 삭제하시겠습니까? 삭제할 시 모든 정보가 삭제됩니다.',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.tbmId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');  
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    
    addAttendee1() {
      // 직영일때
      this.popupOptions.title = "TBM 참석자 검색"; // TBM 참석자 검색
      this.popupOptions.param = {
        type: "multiple",
        plantCd: this.data.plantCd,
        vendorCd: this.data.vendorCd,
        isUserAll: this.data.vendorCd === 'VEN0000000' ? true : false,
      };
      this.popupOptions.target = () => import(`${"@/pages/common/user/userPop.vue"}`);
      this.popupOptions.width = "99%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.data.tbmAttendeeModelList, {
            tbmAttendeeUserId: _item.userId,
          });
          if (index === -1) {
            this.data.tbmAttendeeModelList.push({
              tbmId: this.data.tbmId,
              tbmAttendeeId: uid(),
              tbmAttendeeUserId: _item.userId,
              tbmAttendeeUserName: _item.userName,
              tbmAttendeeJobName: _item.jobName,
              healthStatusCd: "THS0000001",
              mentalFatigueFlag: "N",
              mentalPhychologicalFlag: "N",
              mentalPhysicalFlag: "N",
              physicalDefectFlag: "N",
              tbmDirectFlag: "N",
              remark: "",
              regUserId: this.$store.getters.user.userId,
              editFlag: "C",
            })
          }
        })
      }
    },
    addAttendee2() {
      // 참석자 직접추가
      this.data.tbmAttendeeModelList.push({
        tbmId: this.data.tbmId,
        tbmAttendeeId: uid(),
        tbmAttendeeUserId: "",
        tbmAttendeeUserName: "",
        tbmAttendeeJobName: "",
        healthStatusCd: "THS0000001",
        mentalFatigueFlag: "N",
        mentalPhychologicalFlag: "N",
        mentalPhysicalFlag: "N",
        physicalDefectFlag: "N",
        tbmDirectFlag: "Y",
        remark: "",
        regUserId: this.$store.getters.user.userId,
        editFlag: "C",
      });
    },
    removeAttendee() {
      let selectData = this.$refs["attendeeTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내", // 안내
          message: "하나 이상 선택하세요.", // 하나 이상 선택하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, (item) => {
          if (!this.data.deleteTbmAttendeeModelList) {
            this.data.deleteTbmAttendeeModelList = [];
          }
          if (
            this.$_.findIndex(this.data.deleteTbmAttendeeModelList, {
              tbmAttendeeId: item.tbmAttendeeId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.data.deleteTbmAttendeeModelList.push(item);
          }
          this.data.tbmAttendeeModelList = this.$_.reject(
            this.data.tbmAttendeeModelList,
            item
          );
        });
      }
    },
    callback(data, rowIndex) {
      this.data.tbmAttendeeModelList[rowIndex].electronSignature = data
      this.data.tbmAttendeeModelList[rowIndex].eduAttendFlag = 'Y'
      if(this.data.tbmAttendeeModelList[rowIndex].editFlag !== 'C') {
        this.data.tbmAttendeeModelList[rowIndex].editFlag = 'U'
      }
      let refName = 'proxy_' + rowIndex;
      this.$refs[refName].hide();
    },
    closePopUps() {
      this.$emit('closePopup')
    },
    /* eslint-disable no-unused-vars */ 
    saveDataAppr() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '결재요청 하기 전 입력된 값을 저장합니다.\n\r 진행하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.data.regUserId = this.$store.getters.user.userId
          this.data.chgUserId = this.$store.getters.user.userId

          let promises = [
            {
              func: this.approvalValue
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    getWeekNumber() {

      if (this.data.tbmWorkDate && this.data.tbmWorkDate.length > 0) {
        let currentDate = new Date(this.data.tbmWorkDate[0])
        let startDate = new Date(currentDate.getFullYear(), 0, 1);
        var days = Math.floor((currentDate - startDate) /
          (24 * 60 * 60 * 1000));

        return Math.ceil(days / 7) + '주차';
      } else { 
        return '작업기간 미입력'
      }
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
    },
    approvalValue() {
      return new Promise(resolve => {
        this.isApproval = !this.isApproval
        resolve(true);
      });
    },
    workPermitLoadAttendee() {
      this.$http.url = this.$format(this.getWorkPermitUrl, this.data.sopWorkPermitId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        if (_result.data.workers && _result.data.workers.length > 0) {
          this.$_.forEach(_result.data.workers, _item => {
            let index = this.$_.findIndex(this.data.tbmAttendeeModelList, {
              tbmAttendeeUserName: _item.workerName, 
              tbmAttendeeJobName: _item.jobName,
            });
            if (index === -1) {
              this.data.tbmAttendeeModelList.push({
                tbmId: this.data.tbmId,
                tbmAttendeeId: uid(),
                tbmAttendeeUserId: _item.userId,
                tbmAttendeeUserName: _item.workerName,
                tbmAttendeeJobName: _item.jobName,
                healthStatusCd: "THS0000001",
                mentalFatigueFlag: "N",
                mentalPhychologicalFlag: "N",
                mentalPhysicalFlag: "N",
                physicalDefectFlag: "N",
                tbmWorkPermitFlag: "Y",
                regUserId: this.$store.getters.user.userId,
                editFlag: "C",
              })
            }
          })
        } 
      });
    },
  },
};
</script>